import React from 'react';
import { injectIntl } from 'react-intl-next';
import { tasksAndDecisionsMessages } from '@atlaskit/editor-common/messages';
import { DecisionItem } from '@atlaskit/task-decision';
export var Decision = function Decision(_ref) {
  var contentRef = _ref.contentRef,
    showPlaceholder = _ref.showPlaceholder,
    formatMessage = _ref.intl.formatMessage;
  var placeholder = formatMessage(tasksAndDecisionsMessages.decisionPlaceholder);
  return /*#__PURE__*/React.createElement(DecisionItem, {
    contentRef: contentRef,
    placeholder: placeholder,
    showPlaceholder: showPlaceholder
  });
};
Decision.displayName = 'Decision';
export default injectIntl(Decision);